module.exports = __webpack_public_path__ + "static/assets/13fca624022cc8f762e1da20450c8f03.svg";